<template>
  <div>
    <metainfo>
      <template v-slot:title="{ content }">{{ `${content}` }}</template>
    </metainfo>
    <div class="work">
      <!-- <img
        v-bind:src="require('@/assets/images/sitting-by-tree.png')"
        alt="playing guitar inverted color"
        class="work__headerImage"
      /> -->

      <div class="content-container">
        <h1 class="work__section-heading">My weekend projects</h1>
        <hr class="hr" />
        <main class="work__main-content">
          <Card :projects="projects" @show-story="showStoryModal" />
        </main>

        <div class="whitespace"></div>
      </div>
    </div>

    <PortfolioModal />
  </div>
</template>

<script>
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import Card from "@/components/Card.vue";
import PortfolioModal from "../components/PortfolioModal.vue";
import { useMeta } from "vue-meta";

export default {
  data() {
    return {
      projects: this.$store.state.projects,
      modalData: "",
    };
  },

  name: "Work",
  components: {
    Card,
    PortfolioModal,
  },

  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
      el.style.transform = "scale(0,0)";
    },
    enter(el, done) {
      gsap.to(el, {
        duration: 1,
        opacity: 1,
        scale: 1,
        ease: "bounce.out",
        onComplete: done,
      });
    },
    showStoryModal() {
      console.log(this.$store.state.currentModalData);
      let modal = document.querySelector(".modal");
      modal.classList.remove("hide");
      // modal.style.display = "block";
      modal.style.top = `${window.pageYOffset + 20}px`;
      document.body.classList.add("overflowHidden");
      document.querySelector(".work").classList.add("blurred");
    },
  },

  mounted() {
    gsap.from(".work__card-container", {
      scrollTrigger: {
        trigger: ".work__card-container",
        // start: "130px 100%",
        start: "top 120%",
        // end: "bottom 800px",
        // markers: true,
        // immediateRender: false,
        toggleActions: "play none none none",
      },
      // x: 400,
      // immediateRender: false,
      opacity: 0,
      duration: 1,

      scale: 0,
      y: 200,
      ease: "power1",
      stagger: 0.2,
    });
    const headshotContainer = document.querySelector(".headshot__container");
    const headshotImage = document.querySelector(".headshot-image");
    const hireButton = document.querySelector(".hire-btn");
    const myName = document.querySelector(".my-name");
    if (headshotContainer.classList.contains("hideHeadshot")) {
      headshotContainer.classList.remove("hideHeadshot");
      headshotImage.classList.remove("hideHeadshot");
      hireButton.classList.remove("hideHeadshot");
      myName.classList.remove("hideHeadshot");
    }

    headshotImage.classList.add("headshot-work-image");
    hireButton.classList.add("hire-work-btn");
    myName.classList.add("my-name-work");
  },
 
  beforeUnmount() {
    const headshotImg = document.querySelector(".headshot-image");
    const hireButton = document.querySelector(".hire-btn");
    const myName = document.querySelector(".my-name");
    headshotImg.classList.remove("headshot-work-image");
    hireButton.classList.remove("hire-work-btn");
    myName.classList.remove("my-name-work");
  },
  setup() {
    useMeta({
      title: "Dehsen Ragavulu | Work",
      htmlAttrs: { lang: "en-ZA", amp: true },
      description: [
        {
          name: "description",
          content:
            "Dehsen Ragavulu - UI/UX Designer & Web Developer. Take a look at some of work.",
        },
      ],
    });
  },
};
</script>

}

<style lang="scss">
/********************************************************************************** */
/******  HEADSHOT TRANSITIONS  **************************** */
/********************************************************************************** */

.work {
  &__section-heading,
  &__intro-text {
    text-align: center;
  }
  &__section-heading {
    font-size: 5rem;
    margin-top: 6rem;
    text-align: center;

    @media screen and (max-width: 1112px) {
      font-size: 4rem;
      margin-top: 2rem;
    }
    @media screen and (max-width: 478px) {
      font-size: 3.5rem;
      margin-top: 2rem;
    }
  }

  &__intro-text {
    font-family: "Raleway", sans-serif;
    margin-bottom: 3.6rem;
  }

  &__filter-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 5rem;
    margin-bottom: 9rem;
  }

  &__filter-btn {
    padding: 2rem;
    border-radius: 2px;
    &:not(:last-child) {
      margin-right: 3.3rem;
    }
  }

  &__headerImage {
    max-height: 78.5vh;
    object-fit: cover;
    width: 100%;
    object-position: center 20%;
    animation: change-hue 10000ms infinite linear;
  }

  .hr {
    height: 2.5px;
    border: 0;
    width: 100%;
    background-image: linear-gradient(
      to right,
      rgb(48, 152, 156),
      rgb(107, 63, 136) 15% 25%,
      rgb(48, 108, 133) 40%,
      rgb(0, 25, 89) 75%,
      rgb(48, 152, 156)
    );
    width: 100%;
  }

  &__main-content {
    margin-top: 8rem;
  }

  /******  DESIGN SECTION  ****************************************/

  &__secondary-headings {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__section-heading-secondary {
    font-size: 3rem;
    margin-top: 3.5rem;
  }

  &__main-content-text {
    margin-left: 1rem;
  }

  .whitespace {
    height: 72px;
  }
}

// .headshot__container {
//   animation: slide-up-enter 0.3s ease-in;
//   animation-delay: 1s;
//   // animation-fill-mode: backwards;
// }

@keyframes change-hue {
  0% {
    filter: hue-rotate(0deg);
  }
  50% {
    filter: hue-rotate(84deg);
  }
  100% {
    filter: hue-rotate(0deg);
  }
}

// .fade-enter {
//   opacity: 0;
// }

// .fade-enter-active {
//   transition: opacity 3s ease-out;
// }
</style>
